import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/main.css'
import DesktopBrandCorner from './components/DesktopBrandCorner.vue'

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas, fab)

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('desktop-brand-corner', DesktopBrandCorner)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
